// MOS (Mean Opinion Score) Quality Color Coding and Descriptions

export const getMOSColorHex = (mos) => {
  if (!mos) return '#999'; // Gray for N/A
  if (mos >= 4.0) return '#4caf50'; // Green - Good
  if (mos >= 3.5) return '#2196f3'; // Blue - Fair
  if (mos >= 3.0) return '#ff9800'; // Orange - Annoying
  return '#f44336'; // Red - Poor
};

export const getMOSColorMUI = (mos) => {
  if (!mos) return 'text.secondary';
  if (mos >= 4.0) return 'success.main'; // Green - Good
  if (mos >= 3.5) return 'info.main'; // Blue - Fair
  if (mos >= 3.0) return 'warning.main'; // Orange - Annoying
  return 'error.main'; // Red - Poor
};

export const getMOSChipColor = (mos) => {
  if (!mos) return 'default';
  if (mos >= 4.0) return 'success'; // Green - Good
  if (mos >= 3.5) return 'info'; // Blue - Fair
  if (mos >= 3.0) return 'warning'; // Orange - Annoying
  return 'error'; // Red - Poor
};

export const getMOSQualityText = (mos) => {
  if (!mos) return 'No data available';
  if (mos >= 4.0) return 'Good quality, most users satisfied';
  if (mos >= 3.5) return 'Fair, noticeable degradation but calls are comfortable enough for most users';
  if (mos >= 3.0) return 'Users start finding the call quality annoying or difficult';
  return 'Generally considered poor/unacceptable';
};

export const getMOSWithTooltip = (mos) => {
  const quality = getMOSQualityText(mos);
  const value = mos ? mos.toFixed(2) : 'N/A';
  return {
    value,
    quality,
    color: getMOSColorMUI(mos),
    chipColor: getMOSChipColor(mos),
    hexColor: getMOSColorHex(mos)
  };
};
